import React, { useContext } from "react";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { FavoritesContext } from "../../favorites";
import { Themed } from "../../styles/themes";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";
import { Tooltip } from "../Tooltip";
import { useHeaderContext } from "./HeaderContext";

import styles from "./TopNav.module.scss";

export const TopNav = () => {
    const { headerContent, favoritesUrl, isMobileLayout } = useHeaderContext();
    const favs = useContext(FavoritesContext);
    const hasFavorites = favs.items.length > 0;
    const links = headerContent.top_nav.value;

    if (isMobileLayout) return null;
    if (links.length === 0 && !favoritesUrl) return null;

    return (
        <Themed
            theme="black"
            className={concatClassNames([
                styles.topNav,
                isMobileLayout === null ? styles.layoutUnset : styles.layoutSet,
            ])}
            data-top-nav
        >
            <ul className={styles.links}>
                {links.map((item) => (
                    <li key={item.id}>
                        <Clickable
                            simpleLink={item.value}
                            className={styles.link}
                        />
                    </li>
                ))}
                {favoritesUrl && (
                    <li>
                        <Tooltip label={t`Favorites`}>
                            <Clickable
                                href={favoritesUrl}
                                className={styles.favoritesLink}
                            >
                                <Svg
                                    name="heart"
                                    className={concatClassNames([
                                        styles.heartIcon,
                                        hasFavorites
                                            ? styles.heartIconFilled
                                            : null,
                                    ])}
                                    visuallyHiddenText={t`Favorites`}
                                />
                            </Clickable>
                        </Tooltip>
                    </li>
                )}
            </ul>
        </Themed>
    );
};
